import { render, staticRenderFns } from "./CoozzyLinkIcon.vue?vue&type=template&id=bcf62402&scoped=true"
import script from "./CoozzyLinkIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyLinkIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyLinkIcon.vue?vue&type=style&index=0&id=bcf62402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf62402",
  null
  
)

export default component.exports